// src/pages/boom-sprayer/summary-boom/DetailSummaryBoom.jsx
import React from "react";
import {
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip,
} from "@mui/material";

// Import CustomTableContainer
import CustomTableContainer from "../../../components/CustomScrollContainer";

function DetailSummaryBoom({ detailData, loading, selectedWeek, isRealisasi = false }) {
    if (!selectedWeek) {
        return (
            <Box sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                height: "100%",
                p: 3 
            }}>
                <Typography variant="body2" color="text.secondary">
                    Silakan pilih Week untuk melihat data detail
                </Typography>
            </Box>
        );
    }

    if (detailData.length === 0) {
        return (
            <Box sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                height: "100%",
                p: 3 
            }}>
                <Typography variant="body2" color="text.secondary">
                    {loading ? "Memuat data..." : `Tidak ada data detail ${isRealisasi ? 'realisasi' : 'rencana'} untuk Week ${selectedWeek}`}
                </Typography>
            </Box>
        );
    }

    return (
        <CustomTableContainer
            sx={{
                height: '100%',
                border: "none",
                borderRadius: 0,
                width: "100%",
            }}
            hoverScrollbar={true}
            scrollbarHeight="8px"
            scrollbarWidth="8px"
            scrollbarThumbColor="#c1c1c1"
            scrollbarHoverColor="#a8a8a8"
        >
            <Table 
                stickyHeader 
                size="small"
                sx={{ tableLayout: 'fixed', width: '100%' }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell className="ded-tch" sx={{ width: 60, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                            No
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 200, padding: "8px 4px", backgroundColor: "#f5f5f5" }}>
                            Aktivitas
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 80, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                            Jml Lokasi
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 120, padding: "8px 4px", backgroundColor: "#f5f5f5" }}>
                            ID Lokasi
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 150, padding: "8px 4px", backgroundColor: "#f5f5f5" }}>
                            Nama Lokasi
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 100, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                            Luasan
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 120, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                            Real Bulan Lalu
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 100, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                            Interval Rencana
                        </TableCell>
                        <TableCell className="ded-tch" sx={{ width: 120, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                            {/* Tampilkan kolom yang berbeda berdasarkan Rencana/Realisasi */}
                            {isRealisasi ? "Realisasi Bulan Ini" : "Rencana Bulan Ini"}
                        </TableCell>
                        {isRealisasi && (
                            <TableCell className="ded-tch" sx={{ width: 120, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                                Rencana Bulan Ini
                            </TableCell>
                        )}
                        <TableCell className="ded-tch" sx={{ width: 80, padding: "8px 4px", backgroundColor: "#f5f5f5" }} align="center">
                            Status
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {detailData.map((aktivitasData, aktivitasIndex) => (
                        <React.Fragment key={aktivitasIndex}>
                            {/* Header untuk setiap aktivitas */}
                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                                <TableCell colSpan={isRealisasi ? 11 : 10} sx={{ padding: "8px 4px", fontWeight: 'bold' }}>
                                    {aktivitasIndex + 1}. {aktivitasData.aktivitas} 
                                    <Typography component="span" variant="body2" sx={{ ml: 2, color: 'text.secondary' }}>
                                        ({aktivitasData.jumlah_lokasi} lokasi)
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            
                            {/* Data detail untuk setiap lokasi dalam aktivitas ini */}
                            {aktivitasData.details.map((detail, detailIndex) => {
                                // Tentukan warna status
                                let statusColor = 'default';
                                let statusText = 'Tidak Cocok';
                                
                                if (detail.matches_target_year && detail.matches_target_date) {
                                    statusColor = 'success';
                                    statusText = '✅ Cocok';
                                } else if (detail.matches_target_year && !detail.matches_target_date) {
                                    statusColor = 'warning';
                                    statusText = '⚠️ Tahun Cocok';
                                } else if ((isRealisasi ? detail.tahun_realisasi : detail.tahun_rencana) === '-') {
                                    statusColor = 'error';
                                    statusText = '❌ Tidak Ada Data';
                                }
                                
                                return (
                                    <TableRow key={detailIndex} hover>
                                        <TableCell sx={{ padding: "8px 4px" }} align="center">
                                            {aktivitasIndex + 1}.{detailIndex + 1}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }}>
                                            {detailIndex === 0 ? aktivitasData.aktivitas : ''}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }} align="center">
                                            {detailIndex === 0 ? aktivitasData.jumlah_lokasi : ''}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }}>
                                            {detail.id_lokasi}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }}>
                                            {detail.nama_lokasi}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }} align="center">
                                            {detail.luas_aktif}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }} align="center">
                                            {detail.real_bulan_lalu}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }} align="center">
                                            {detail.interval_rencana}
                                        </TableCell>
                                        <TableCell sx={{ padding: "8px 4px" }} align="center">
                                            {/* Tampilkan data yang berbeda berdasarkan Rencana/Realisasi */}
                                            {isRealisasi ? detail.real_bulan_ini : detail.rencana_bulan_ini}
                                        </TableCell>
                                        {isRealisasi && (
                                            <TableCell sx={{ padding: "8px 4px" }} align="center">
                                                {detail.rencana_bulan_ini}
                                            </TableCell>
                                        )}
                                        <TableCell sx={{ padding: "8px 4px" }} align="center">
                                            <Chip 
                                                label={statusText} 
                                                size="small" 
                                                color={statusColor}
                                                variant="outlined"
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                            
                            {/* Baris kosong sebagai separator */}
                            {aktivitasIndex < detailData.length - 1 && (
                                <TableRow>
                                    <TableCell colSpan={isRealisasi ? 11 : 10} sx={{ height: 16, backgroundColor: '#f0f0f0' }}></TableCell>
                                </TableRow>
                            )}
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </CustomTableContainer>
    );
}

export default DetailSummaryBoom;